import * as React from 'react';
import { Box, CircularProgress } from '@material-ui/core';

export interface LoadingImageProps {
  src: string;
  alt: string;
  className?: string;
}

const LoadingImage: React.FC<LoadingImageProps> = ({ src, alt, className }) => {
  const [isLoading, setIsLoading] = React.useState(true);

  const handleLoaded = () => {
    setIsLoading(false);
  };

  // Keep the image hidden until fully decoded so it never paints progressively.
  return (
    <Box position="relative" width="100%" minHeight={isLoading ? 200 : undefined}>
      {isLoading && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress size={32} />
        </Box>
      )}
      <img
        src={src}
        alt={alt}
        className={className}
        decoding="async"
        onLoad={handleLoaded}
        onError={handleLoaded}
        style={{ opacity: isLoading ? 0 : 1, transition: 'opacity 0.3s ease-in' }}
      />
    </Box>
  );
};

export default LoadingImage;
